/**
 * 管理后台 - 嘉宾管理 API
 */

import { httpGet, httpPost, httpPut, httpDelete } from '@/services/http';
import { transformGuest, transformGuestToBackend, BackendGuest, FrontendGuest } from '@/services/transform';

/** GET /api/admin/guests - 列出所有嘉宾 */
export async function getAdminGuests(): Promise<FrontendGuest[]> {
  try {
    const data = await httpGet<BackendGuest[]>('/admin/guests');
    const guests = data.map(transformGuest);
    
    // Deduplicate by ID to prevent React key warnings
    const seen = new Set<string>();
    return guests.filter((g) => {
      if (seen.has(g.id)) return false;
      seen.add(g.id);
      return true;
    });
  } catch (error) {
    console.error('获取管理嘉宾列表失败:', error);
    return [];
  }
}

/** POST /api/admin/guests - 创建嘉宾 */
export async function createAdminGuest(data: Partial<FrontendGuest>): Promise<FrontendGuest | null> {
  try {
    const backendData = transformGuestToBackend(data);
    const result = await httpPost<BackendGuest>('/admin/guests', backendData);
    return transformGuest(result);
  } catch (error) {
    console.error('创建嘉宾失败:', error);
    return null;
  }
}

/** PUT /api/admin/guests/:id - 更新嘉宾 */
export async function updateAdminGuest(id: string, data: Partial<FrontendGuest>): Promise<FrontendGuest | null> {
  try {
    const backendData = transformGuestToBackend(data);
    const result = await httpPut<BackendGuest>(`/admin/guests/${id}`, backendData);
    return transformGuest(result);
  } catch (error) {
    console.error('更新嘉宾失败:', error);
    return null;
  }
}

/** DELETE /api/admin/guests/:id - 删除嘉宾 */
export async function deleteAdminGuest(id: string): Promise<boolean> {
  try {
    await httpDelete(`/admin/guests/${id}`);
    return true;
  } catch (error) {
    console.error('删除嘉宾失败:', error);
    return false;
  }
}
